var React = require("react");

var styled = require("styled-components").default;

module.exports = NavigationToolbar;

function NavigationToolbar(props) {
  return React.createElement(StyledNavigationToolbar, null, props.children);
}

NavigationToolbar.defaultProps = {
  children: []
};
var StyledNavigationToolbar = styled.div.withConfig({
  displayName: "navigation-toolbar__StyledNavigationToolbar"
})(["display:flex;align-items:center;justify-content:space-between;height:40px;padding:10px 15px;background-color:", ";box-sizing:\"border-box\";"], function (props) {
  return props.theme.colors.backgroundSecondary;
});
//# sourceMappingURL=index.js.map